<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import {
		storeBuilderPreview,
		storeShowTools,
		storeElementID,
		storeData,
		storeBooking,
	} from '../library/scripts/Store.svelte'
	import { styles } from '../library/scripts/styles'
	import { validate } from '../library/scripts/validate'
	import { send_mail } from '../builder/builderUtils'
	import * as animateScroll from 'svelte-scrollto'
	import ThreeCols from '../library/columLayouts/ThreeCols.svelte'
	import DatePicker from '../library/LayoutStuff/DatePicker.svelte'
	import Shader from '../library/ShadersAndSpinners/Shader.svelte'
	import Spinner from '../library/ShadersAndSpinners/SpinnerCircle.svelte'
	import Alert from '../modals/Alert.svelte'
	import IntersectionObserver from 'svelte-intersection-observer'

	const globals = getContext('globals')
	const fsS = globals.fsS
	const fsN = globals.fsN
	const iconColor = globals.colorDark
	const iconHover = globals.colorError
	const iconSize = globals.icon
	const builderToolbar = globals.builderToolbar
	const builderToolbarHover = globals.builderToolbarHover

	const devHeight = globals.devHeight

	const winLocation = window.location.toString()

	if (winLocation.indexOf('preview') > -1) storeBooking.set(false)

	//observer
	let element
	const set_observer = (e) => {
		if (e === 'set' && devHeight > 600) {
			element.style.filter = 'blur(5px)'
			storeBooking.set(false)
		} else if (e !== 'set' && devHeight > 600) {
			element.style.filter = 'blur(0px)'
		}
	}

	//error handling
	let error = false
	let errorMessage = null

	//send message
	let sendMessage = false
	let showSpinner = false
	let showResponse = false

	let elementID

	let configFile
	let bookingBlock
	let backgroundColor
	let blockWidth
	let inputFontColor
	let lableFontColor
	let lableFontFF
	let labelFontSize = fsS
	let labelMarginTop
	let labelMarginBottom
	let labelWeight
	let labelStyle
	let labelDeco
	let confFF
	let confColor
	let inputFontSize = globals.fsS
	let inputFontFamily
	let inputBorderWidth
	let inputBorderColor
	let inputBg
	let inputShadowX
	let inputShadowY
	let inputShadowBlur
	let inputShadowColor
	let inputFocus
	let shadowX
	let shadowY
	let shadowBlur
	let shadowColor
	let titleBarSC
	let titleBarSY
	let titleBarSB
	let titleAlign
	let titleVAlign
	let titleColor
	let titleBackgroundColor
	let titleFontFamily
	let titleFontSize
	let titleFontStyle
	let titleFontWeight
	let titleFontDeco
	let titleShadowX
	let titleShadowY
	let titleShadowBlur
	let titleShadowColor
	let titleHeight
	let titleP
	let titleMB
	let titleMT
	let height
	let padding
	let marginTop
	let marginBottom
	let buttonBg
	let buttonHover
	let buttonFontHover
	let buttonFontColor
	let buttonFontFamily
	let buttonFontSize = fsS
	let buttonBorderWidth
	let buttonBorderColor
	let buttonBorderRadius
	let buttonText
	let borderBottomRadius
	let borderLeftWidth
	let borderLeftStyle
	let borderLeftColor
	let borderTopWidth
	let borderTopStyle
	let borderTopColor
	let borderRightWidth
	let borderRightStyle
	let borderRightColor
	let borderBottomWidth
	let borderBottomStyle
	let borderBottomColor
	let borderTopRadius
	let pickerColorSelected
	let pickerColor
	let pickerColorDisabled
	let pickerColorBorder
	let pickerColorHover
	let pickerDayHover
	let respColor
	let mailAns1
	let mailAns2
	let selectionBG
	let selectionBLC
	let selectionBLW
	let selectionBTC
	let selectionBTW
	let selectionBBC
	let selectionBBW
	let selectionBRC
	let selectionBRW
	let selectionSC
	let selectionSX
	let selectionSY
	let selectionSB
	let confWeight
	let confStyle
	let confDeco

	//option hours
	let optHours = ['HH', '11', '12', '13', '14', '17', '18', '19', '20', '21']
	let optMinutes = ['MM', '00', '15', '30', '45']

	// new variables
	let email = '--'
	let name = '--'
	let phone = '--'
	let message = '--'
	let bookDate = '--'
	let bookHour
	let bookMinutes
	let bookGuests = 1

	//reset values on start
	const reset_value = (r) => {
		switch (r) {
			case 'name':
				name = null
				break

			case 'phone':
				phone = null
				break

			case 'email':
				email = null
				break

			case 'message':
				message = null
				break
		}
	}

	const set_date = (e) => {
		bookDate = e.detail.value
	}

	const show_form = () => {
		showForm = showForm === true ? false : true
		storeBooking.set(showForm)
		animateScroll.scrollTo({ element: '#booking' })
	}

	const stoData = storeData.subscribe((value) => {
		if (value) {
			value.blocks.forEach((block) => {
				if (block.blockName === 'booking') {
					bookingBlock = block
					backgroundColor = bookingBlock.backgroundColor
					blockWidth = bookingBlock.blockTitleWidth + '%'
					borderTopRadius = bookingBlock.borderTopRadius + 'px'
					borderBottomRadius = bookingBlock.borderBottomRadius + 'px'
					borderLeftWidth = bookingBlock.borderLeftWidth + 'px'
					borderLeftStyle = bookingBlock.borderLeftStyle
					borderLeftColor = bookingBlock.borderLeftColor
					borderTopWidth = bookingBlock.borderTopWidth + 'px'
					borderTopStyle = bookingBlock.borderTopStyle
					borderTopColor = bookingBlock.borderTopColor
					borderRightWidth = bookingBlock.borderRightWidth + 'px'
					borderRightStyle = bookingBlock.borderRightStyle
					borderRightColor = bookingBlock.borderRightColor
					borderBottomWidth = bookingBlock.borderBottomWidth + 'px'
					borderBottomStyle = bookingBlock.borderBottomStyle
					borderBottomColor = bookingBlock.borderBottomColor
					labelFontSize = bookingBlock.labelFontSize
					lableFontColor = bookingBlock.lableFontColor
					lableFontFF = bookingBlock.lableFontFF
					labelMarginTop = bookingBlock.labelMarginTop + 'px'
					labelMarginBottom = bookingBlock.labelMarginBottom + 'px'
					confFF = bookingBlock.confFF
					confColor = bookingBlock.confColor
					inputFontColor = bookingBlock.inputFontColor
					inputFontFamily = bookingBlock.inputFontFamily
					inputFontSize = { fsS }
					inputBorderWidth = bookingBlock.inputBorderWidth + 'px'
					inputBorderColor = bookingBlock.inputBorderColor
					inputBg = bookingBlock.inputBg
					inputFocus = bookingBlock.inputFocusColor
					inputShadowX = bookingBlock.inputShadowX + 'px'
					inputShadowY = bookingBlock.inputShadowY + 'px'
					inputShadowBlur = bookingBlock.inputShadowBlur + 'px'
					inputShadowColor = bookingBlock.inputShadowColor
					shadowX = bookingBlock.blockBoxShadowX + 'px'
					shadowY = bookingBlock.blockBoxShadowY + 'px'
					shadowBlur = bookingBlock.blockBoxShadowBlur + 'px'
					shadowColor = bookingBlock.blockBoxShadowColor
					titleHeight = bookingBlock.blockTitleHeight + 'px'
					titleVAlign = bookingBlock.blockTitleAlignVertical
					titleAlign = bookingBlock.blockTitleAlignHorizontal
					titleColor = bookingBlock.blockTitleFontColor
					titleBackgroundColor = bookingBlock.blockTitleBackgroundColor
					titleBarSC = bookingBlock.blockTitlebarSC
					titleBarSY = bookingBlock.blockTitlebarY + 'px'
					titleBarSB = bookingBlock.blockTitlebarB + 'px'
					titleFontFamily = bookingBlock.blockTitleFontFamily
					titleFontSize = bookingBlock.blockTitleFontSize
					titleFontStyle = bookingBlock.blockTitleFontStyle
					titleFontWeight = bookingBlock.blockTitleFontWeight
					titleFontDeco = bookingBlock.blockTitleFontDeco
					titleShadowX = bookingBlock.blockTitleShadowOffsetX + 'px'
					titleShadowY = bookingBlock.blockTitleShadowOffsetY + 'px'
					titleShadowBlur = bookingBlock.blockTitleShadowBlur + 'px'
					titleShadowColor = bookingBlock.blockTitleShadowColor
					titleMT = bookingBlock.blockTitleMarginTop + '%'
					titleMB = bookingBlock.blockTitleMarginBottom + '%'
					titleP = bookingBlock.blockTitlePadding + '%'
					padding = bookingBlock.padding + '%'
					marginTop = bookingBlock.marginTop + '%'
					marginBottom = bookingBlock.marginBottom + '%'
					buttonBg = bookingBlock.buttonBg
					buttonHover = bookingBlock.buttonBgHover
					buttonFontHover = bookingBlock.buttonFontHover
					buttonFontColor = bookingBlock.buttonFontColor
					buttonFontFamily = bookingBlock.buttonFontFamily
					buttonBorderWidth = bookingBlock.buttonBorderWidth + 'px'
					buttonBorderColor = bookingBlock.buttonBorderColor
					buttonBorderRadius = bookingBlock.buttonBorderRadius + 'px'
					buttonText = bookingBlock.buttonText
					pickerColor = bookingBlock.pickerColor
					pickerColorSelected = bookingBlock.pickerColorSelected
					pickerColorDisabled = bookingBlock.pickerColorDisabled
					pickerColorBorder = bookingBlock.pickerColorBorder
					pickerColorHover = bookingBlock.pickerColorHover
					pickerDayHover = bookingBlock.pickerDayHover
					respColor = bookingBlock.respColor
					mailAns1 = bookingBlock.content[0].ans1
					mailAns2 = bookingBlock.content[0].ans2
					selectionBG = bookingBlock.selectionBG
					labelWeight = bookingBlock.labelWeight
					labelStyle = bookingBlock.labelStyle
					labelDeco = bookingBlock.labelDeco
					selectionBLC = bookingBlock.selectionBLC
					selectionBLW = bookingBlock.selectionBLW + 'px'
					selectionBTC = bookingBlock.selectionBTC
					selectionBTW = bookingBlock.selectionBTW + 'px'
					selectionBBC = bookingBlock.selectionBBC
					selectionBBW = bookingBlock.selectionBBW + 'px'
					selectionBRC = bookingBlock.selectionBRC
					selectionBRW = bookingBlock.selectionBRW + 'px'
					selectionSC = bookingBlock.selectionSC
					selectionSX = bookingBlock.selectionSX + 'px'
					selectionSY = bookingBlock.selectionSY + 'px'
					selectionSB = bookingBlock.selectionSB + 'px'
					confWeight = bookingBlock.confWeight
					confStyle = bookingBlock.confStyle
					confDeco = bookingBlock.confDeco
				}
			})
			configFile = value
		}
	})

	let showPreview
	const stoPreview = storeBuilderPreview.subscribe((value) => {
		showPreview = value
	})

	const set_elementID = (e) => {
		storeShowTools.set(true)
		elementID = e
		storeElementID.set(e)
		storeBooking.set(true)
		animateScroll.scrollTo({ element: '#booking' })
	}

	const send_booking = async () => {
		if (!name) {
			error = true
			errorMessage = 'please enter your name'
			return
		}
		const chckMail = validate('email', email)
		if (!chckMail) {
			error = true
			errorMessage = 'please enter a valid email-address'
			return
		}
		if (!message) {
			error = true
			errorMessage = 'please enter a message'
			return
		}

		sendMessage = true
		showSpinner = true
		const data = {
			receiver: 'admin',
			cmd: 'booktable',
			sendername: name,
			mail: email,
			phone: phone,
			msg: message,
			date: bookDate,
			time: bookHour + ' : ' + bookMinutes,
			guests: bookGuests,
		}
		const sendMail = await send_mail('send_mail', data)
		//timeout
		if (sendMail) {
			showSpinner = false
			showResponse = true

			const toSend = setTimeout(() => {
				sendMessage = false
				showSpinner = false
				showResponse = false
				email = null
				name = null
				message = null
				showForm = false
				email = '--'
				name = '--'
				phone = '--'
				message = '--'
				bookDate = '--'
				clearTimeout(toSend)
			}, 5000)
		}
	}

	let showForm
	const stoContact = storeBooking.subscribe((value) => {
		showForm = value
	})

	const close_alert = () => {
		error = false
	}

	onDestroy(() => {
		stoPreview
		stoData
		stoContact
	})
</script>

{#if !showPreview && configFile.widgets.indexOf('admin') > -1}
	<div
		class="content_row"
		use:styles={{ fsS, builderToolbar, builderToolbarHover }}
		on:click={() => set_elementID('booking')}
		on:keydown={() => set_elementID('booking')}
	>
		<div style="margin-left:20px;">*OPEN BOOKING TOOL*</div>
	</div>
{/if}
{#if configFile}
	{#each configFile.blocks as block}
		{#if block.blockName === 'booking'}
			<IntersectionObserver
				{element}
				threshold="0.5"
				on:observe={(e) => {
					if (!e.detail.isIntersecting) {
						set_observer('set')
					} else {
						set_observer('unset')
					}
				}}
			>
				<main
					id="booking"
					bind:this={element}
					use:styles={{
						height,
						padding,
						marginTop,
						marginBottom,
					}}
				>
					<div
						class="booking_outer"
						use:styles={{
							shadowX,
							shadowY,
							shadowBlur,
							shadowColor,
							borderTopRadius,
							borderBottomRadius,
							borderLeftWidth,
							borderLeftStyle,
							borderLeftColor,
							borderTopWidth,
							borderTopStyle,
							borderTopColor,
							borderRightWidth,
							borderRightStyle,
							borderRightColor,
							borderBottomWidth,
							borderBottomStyle,
							borderBottomColor,
						}}
					>
						<div
							id="booking_title"
							class="title_container"
							use:styles={{
								blockWidth,
								titleHeight,
								titleAlign,
								titleVAlign,
								shadowX,
								shadowY,
								shadowBlur,
								shadowColor,
								borderTopRadius,
								borderTopRadius,
								borderTopRadius,
								borderBottomRadius,
								borderBottomRadius,
								borderLeftWidth,
								borderLeftStyle,
								borderLeftColor,
								borderTopWidth,
								borderTopStyle,
								borderTopColor,
								borderRightWidth,
								borderRightStyle,
								borderRightColor,
								borderBottomWidth,
								borderBottomStyle,
								borderBottomColor,
								titleColor,
								titleBackgroundColor,
								titleFontFamily,
								titleBarSC,
								titleBarSY,
								titleBarSB,
								titleFontSize,
								titleFontStyle,
								titleFontWeight,
								titleFontDeco,
								titleShadowX,
								titleShadowY,
								titleShadowBlur,
								titleShadowColor,
								titleMT,
								titleMB,
								titleP,
							}}
							on:click={show_form}
							on:keydown={show_form}
						>
							{block.blockTitle}
						</div>
						{#if showForm}
							{#if sendMessage}
								<div class="shader">
									{#if showSpinner}
										<Spinner size="3vw" color="hsl(0,0%,60%)" info="send booking" fontSize={fsS} />
									{:else if showResponse}
										<div class="response" use:styles={{ respColor, fsN }}>
											<div style="margin-bottom:30px;">{name}</div>
											<div style="margin-bottom:15px;margin-top:15px;">{mailAns1}</div>
											<div>{mailAns2}</div>
										</div>
									{/if}
								</div>
							{/if}
							<div
								id="contactContainer"
								class="booking_container"
								use:styles={{
									selectionBG,
									fsN,
									selectionBLC,
									selectionBLW,
									selectionBTC,
									selectionBTW,
									selectionBRC,
									selectionBRW,
									selectionBBC,
									selectionBBW,
									selectionSC,
									selectionSX,
									selectionSY,
									selectionSB,
								}}
								transition:slide={{ duration: 1000 }}
							>
								<ThreeCols column="300px" alignVertical="top">
									<div slot="column1" class="column1">
										<div
											class="label"
											use:styles={{
												labelFontSize,
												lableFontColor,
												lableFontFF,
												labelMarginTop,
												labelMarginBottom,
												labelWeight,
												labelStyle,
												labelDeco,
											}}
										>
											Name
										</div>
										<input
											type="text"
											bind:value={name}
											on:focus={() => reset_value('name')}
											use:styles={{
												inputFontColor,
												inputFontFamily,
												inputFontSize,
												inputBorderWidth,
												inputBorderColor,
												inputBg,
												inputFocus,
												inputShadowX,
												inputShadowY,
												inputShadowBlur,
												inputShadowColor,
											}}
										/>

										<div
											class="label"
											use:styles={{
												labelFontSize,
												lableFontColor,
												lableFontFF,
												labelMarginTop,
												labelMarginBottom,
												labelWeight,
												labelStyle,
												labelDeco,
											}}
										>
											Phone
										</div>
										<input
											type="text"
											bind:value={phone}
											on:focus={() => reset_value('phone')}
											use:styles={{
												inputFontColor,
												inputFontFamily,
												inputFontSize,
												inputBorderWidth,
												inputBorderColor,
												inputBg,
												inputFocus,
												inputShadowX,
												inputShadowY,
												inputShadowBlur,
												inputShadowColor,
											}}
										/>

										<div
											class="label"
											use:styles={{
												labelFontSize,
												lableFontColor,
												lableFontFF,
												labelMarginTop,
												labelMarginBottom,
												labelWeight,
												labelStyle,
												labelDeco,
											}}
										>
											Email
										</div>
										<input
											type="text"
											bind:value={email}
											on:focus={() => reset_value('email')}
											use:styles={{
												inputFontColor,
												inputFontFamily,
												inputFontSize,
												inputBorderWidth,
												inputBorderColor,
												inputBg,
												inputFocus,
												inputShadowX,
												inputShadowY,
												inputShadowBlur,
												inputShadowColor,
											}}
										/>
									</div>

									<div slot="column2" class="column2">
										<div class="column">
											<div
												class="label"
												use:styles={{
													labelFontSize,
													lableFontColor,
													lableFontFF,
													labelMarginTop,
													labelMarginBottom,
													labelWeight,
													labelStyle,
													labelDeco,
												}}
											>
												Select Date
											</div>

											<DatePicker
												disablePrevious={true}
												colorSelected={pickerColorSelected}
												colorDisabled={pickerColorDisabled}
												colorHover={pickerColorHover}
												color={inputFontColor}
												fontFamily={inputFontFamily}
												colorBorder={inputBorderColor}
												backgroundColor={inputBg}
												colorShadow={inputShadowColor}
												shadowX={inputShadowX}
												shadowY={inputShadowY}
												shadowB={inputShadowBlur}
												on:getdate={set_date}
											/>

											<div
												class="label"
												use:styles={{
													labelFontSize,
													lableFontColor,
													lableFontFF,
													labelMarginTop,
													labelMarginBottom,
													labelWeight,
													labelStyle,
													labelDeco,
												}}
											>
												Select Time & Guests
											</div>
											<div class="time_row">
												<select
													bind:value={bookHour}
													style="width:clamp(60px, 6.5vw, 100px);margin-right:5px;"
													use:styles={{
														inputFontColor,
														inputFontFamily,
														inputFontSize,
														inputBorderWidth,
														inputBorderColor,
														inputBg,
														inputFocus,
														inputShadowX,
														inputShadowY,
														inputShadowBlur,
														inputShadowColor,
													}}
												>
													{#each optHours as hour}
														<option value={hour}>
															{hour}
														</option>
													{/each}
												</select>

												<select
													bind:value={bookMinutes}
													style="width:clamp(60px, 6.5vw, 100px);margin-right:5px;"
													use:styles={{
														inputFontColor,
														inputFontFamily,
														inputFontSize,
														inputBorderWidth,
														inputBorderColor,
														inputBg,
														inputFocus,
														inputShadowX,
														inputShadowY,
														inputShadowBlur,
														inputShadowColor,
													}}
												>
													{#each optMinutes as minute}
														<option value={minute}>
															{minute}
														</option>
													{/each}
												</select>

												<input
													type="number"
													bind:value={bookGuests}
													style="width:clamp(60px, 6.5vw, 100px);"
													min="1"
													use:styles={{
														inputFontColor,
														inputFontFamily,
														inputFontSize,
														inputBorderWidth,
														inputBorderColor,
														inputBg,
														inputFocus,
														inputShadowX,
														inputShadowY,
														inputShadowBlur,
														inputShadowColor,
													}}
												/>
											</div>

											<div
												class="label"
												use:styles={{
													labelFontSize,
													lableFontColor,
													lableFontFF,
													labelMarginTop,
													labelMarginBottom,
													labelWeight,
													labelStyle,
													labelDeco,
												}}
											>
												Short Message
											</div>
											<input
												type="text"
												bind:value={message}
												on:focus={() => reset_value('message')}
												use:styles={{
													inputFontColor,
													inputFontFamily,
													inputFontSize,
													inputBorderWidth,
													inputBorderColor,
													inputBg,
													inputFocus,
													inputShadowX,
													inputShadowY,
													inputShadowBlur,
													inputShadowColor,
												}}
											/>
										</div>
									</div>

									<div slot="column3">
										<div class="column3">
											<div
												class="label"
												use:styles={{
													labelFontSize,
													lableFontColor,
													lableFontFF,
													labelMarginTop,
													labelMarginBottom,
													labelWeight,
													labelStyle,
													labelDeco,
												}}
											>
												Confirmation
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Date:</div>
												<div>{bookDate}</div>
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Time</div>
												<div>{bookHour}:{bookMinutes}</div>
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Guests</div>
												<div>{bookGuests}</div>
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Name</div>
												<div>{name}</div>
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Phone</div>
												<div>{phone}</div>
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Email</div>
												<div>{email}</div>
											</div>

											<div class="conf_row" use:styles={{ inputFontSize, inputFontFamily, lableFontColor }}>
												<div>Message</div>
												<div>{message}</div>
											</div>
										</div>
									</div>
								</ThreeCols>
								<div class="button_container">
									<button
										on:click={send_booking}
										use:styles={{
											buttonBg,
											buttonHover,
											buttonFontColor,
											buttonFontHover,
											buttonFontFamily,
											buttonFontSize,
											buttonBorderWidth,
											buttonBorderColor,
											buttonBorderRadius,
											inputShadowX,
											inputShadowY,
											inputShadowBlur,
											inputShadowColor,
										}}>confirm</button
									>
								</div>
							</div>
						{/if}
					</div>
				</main>
			</IntersectionObserver>
		{/if}
	{/each}
{/if}

{#if error}
	<Shader>
		<div slot="content"><Alert message={errorMessage} showOkButton={false} on:alertclose={close_alert} /></div>
	</Shader>
{/if}

<style>
	main {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: var(--height);
		padding: var(--padding);
		margin-top: var(--marginTop);
		margin-bottom: var(--marginBottom);
	}

	.booking_outer {
		padding: 20px;
		box-shadow: var(--shadowX) var(--shadowY) var(--shadowBlur) var(--shadowColor);
		border-top-left-radius: var(--borderTopRadius);
		border-top-left-radius: var(--borderTopRadius);
		border-top-right-radius: var(--borderTopRadius);
		border-bottom-left-radius: var(--borderBottomRadius);
		border-bottom-right-radius: var(--borderBottomRadius);
		border-left-width: var(--borderLeftWidth);
		border-left-style: var(--borderLeftStyle);
		border-left-color: var(--borderLeftColor);
		border-top-width: var(--borderTopWidth);
		border-top-style: var(--borderTopStyle);
		border-top-color: var(--borderTopColor);
		border-right-width: var(--borderRightWidth);
		border-right-style: var(--borderRightStyle);
		border-right-color: var(--borderRightColor);
		border-bottom-width: var(--borderBottomWidth);
		border-bottom-style: var(--borderBottomStyle);
		border-bottom-color: var(--borderBottomColor);
	}

	.column1 {
		background-color: transparent;
	}

	.column2 {
		background-color: transparent;
	}

	.column3 {
		background-color: transparent;
	}

	.conf_row {
		display: grid;
		grid-template-columns: 30% 70%;
		margin-bottom: 15px;
		color: var(--lableFontColor);
		font-family: var(--inputFontFamily);
		font-size: var(--inputFontSize);
	}

	.time_row {
		display: flex;
	}

	button {
		background-color: var(--buttonBg);
		color: var(--buttonFontColor);
		font-family: var(--buttonFontFamily);
		font-size: var(--buttonFontSize);
		border: var(--buttonBorderWidth) solid var(--buttonBorderColor);
		border-radius: var(--buttonBorderRadius);
		box-shadow: var(--inputShadowX) var(--inputShadowY) var(--inputShadowBlur) var(--inputShadowColor);
		width: fit-content;
		height: fit-content;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
		color: var(--buttonFontHover);
	}

	.booking_container {
		display: flex;
		flex-direction: column;
		margin-top: 25px;
		align-items: center;
		justify-content: flex-start;
		background-color: var(--selectionBG);
		padding: 10px;
		font-size: var(--fsN);
		border-left: var(--selectionBLW) solid var(--selectionBLC);
		border-top: var(--selectionBTW) solid var(--selectionBTC);
		border-right: var(--selectionBRW) solid var(--selectionBRC);
		border-bottom: var(--selectionBBW) solid var(--selectionBBC);
		box-shadow: var(--selectionSX) var(--selectionSY) var(--selectionSB) var(--selectionSC);
	}

	input,
	select {
		outline: none;
		width: 90%;
		color: var(--inputFontColor);
		font-family: var(--inputFontFamily);
		font-size: var(--inputFontSize);
		border: var(--inputBorderWidth) solid var(--inputBorderColor);
		background-color: var(--inputBg);
		box-shadow: var(--inputShadowX) var(--inputShadowY) var(--inputShadowBlur) var(--inputShadowColor);
	}

	input:focus {
		background-color: var(--inputFocus);
	}

	.title_container {
		display: flex;
		width: var(--blockWidth);
		height: var(--titleHeight);
		justify-content: var(--titleAlign);
		align-items: var(--titleVAlign);
		color: var(--titleColor);
		background-color: var(--titleBackgroundColor);
		font-family: var(--titleFontFamily);
		font-size: var(--titleFontSize);
		font-style: var(--titleFontStyle);
		font-weight: var(--titleFontWeight);
		text-decoration: var(--titleFontDeco);
		text-shadow: var(--titleShadowX) var(--titleShadowY) var(--titleShadowBlur) var(--titleShadowColor);
		margin-top: var(--titleMT);
		margin-bottom: var(--titleMB);
		padding: var(--titleP);
		box-shadow: 0px var(--titleBarSY) var(--titleBarSB) var(--titleBarSC);
		cursor: pointer;
	}

	.shader {
		position: absolute;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		top: 0px;
		left: 0px;
		height: 100%;
		width: 100%;
		z-index: 1;
		background-color: hsla(0, 0%, 0%, 0.7);
	}

	.response {
		display: flex;
		flex-direction: column;
		width: 70%;
		align-items: center;
		color: var(--respColor);
		font-size: var(--fsN);
	}

	.button_container {
		display: flex;
		width: 90%;
		justify-content: flex-end;
	}

	.label {
		color: var(--lableFontColor);
		font-family: var(--lableFontFF);
		font-size: var(--labelFontSize);
		margin-top: var(--labelMarginTop);
		margin-bottom: var(--labelMarginBottom);
		font-weight: var(--labelWeight);
		font-style: var(--labelStyle);
		text-decoration: var(--labelDeco);
	}

	.content_row {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 100%;
		cursor: pointer;
		font-style: italic;
		font-size: var(--fsS);
		background-color: var(--builderToolbar);
		height: 40px;
		border-bottom: 1px solid hsl(0, 0%, 50%);
	}

	.content_row:hover {
		background-color: var(--builderToolbarHover);
	}
</style>
